import { post, postFile } from "@/http/index.js";
import { MEMBER } from "@/utils/http.js";

/**
 * 上传文件
 */
export const uploadFile = params => postFile(MEMBER + "/file/upload", params);

/**
 * 删除文件
 * @param {*} id
 */
export const delFile = params => post(MEMBER + "/file/delete", params);
